import { stimaNote } from '@slims/shared/types';
import { Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../popover/popover';

export interface StimaInfoProps {
	/** Quota stimata del valore (0-1). Sotto l'1% la «i» non compare. */
	share: number | null | undefined;
}

/**
 * La «i» accanto a un valore energetico che per una parte viene dai livelli
 * stimato o tipico della curva, non da una misura né da un dato GSE
 * (INB-354): al clic dice quanta parte. Dove la card ha già la «i» del calcolo
 * (`CalcTrace`) la stessa riga va nella sua nota, con `stimaNote`, e questa
 * non serve.
 */
export function StimaInfo({ share }: StimaInfoProps) {
	const text = stimaNote(share);
	if (!text) return null;
	return (
		<Popover>
			<PopoverTrigger
				type="button"
				title={text}
				aria-label={`Valore in parte stimato: ${text}`}
				className="tap-target flex items-center justify-center rounded text-text-muted transition-colors hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background"
			>
				<Info className="h-3 w-3" />
			</PopoverTrigger>
			<PopoverContent align="end" className="w-64 text-[12px] leading-relaxed text-text">
				{text}
			</PopoverContent>
		</Popover>
	);
}
